import {
  EssentialsMessageMetadata,
  LyraLibraryResource,
  transformLyraLibraryResourceToEssentialsMetadata,
} from './Messages'

/**
 * Parses essentials metadata from either attached resources or a legacy essentials string field.
 *
 * @param attachedResources - Array of LyraLibraryResource objects from the backend
 * @param essentials - Legacy string field containing JSON-encoded essentials data
 * @returns Parsed essentials metadata array, or undefined if parsing fails or no data exists
 */
export const parseEssentialsMetadata = (
  attachedResources?: LyraLibraryResource[],
  essentials?: string | EssentialsMessageMetadata[],
): EssentialsMessageMetadata[] | undefined => {
  // Assumed usage: Use attached_resources if available
  if (attachedResources) {
    return attachedResources.map(transformLyraLibraryResourceToEssentialsMetadata)
  }

  // Parse essentials string field
  if (typeof essentials === 'string') {
    try {
      return JSON.parse(essentials)
    } catch (error) {
      // Log parsing error and continue without essentials data
      console.error('Failed to parse essentials metadata:', error)
      return undefined
    }
  }

  // Use essentials as-is if already parsed
  return essentials
}
